import { CourtesyRequestProps } from '../hooks/courtesy-request'
import {
  CourtesySectorProps,
  CourtesyTicketsProps,
} from '../hooks/producer-pdv'
import { getGenderDescription } from './gender-mapper'
export interface CourtesyRequestInitialProps {
  sector_id: string
  ticket_id: string
  ticket_amount: number
  user_idetifier: string
  confirmation: boolean
  payload: CourtesyRequestProps
}

export interface SectorProps {
  sector_id: number
  sector_name: string
  event_name: string
}

export interface UserDataProps {
  success: boolean
  data: {
    cpf: string
    email: string
    id: number
    nome: string
  }
  dataAsArray: DataGridProps[]
}
export interface DataGridProps {
  title: string
  value: string
}

export interface DataConfirmationProps {
  event_data: DataGridProps[]
  user_data: UserDataProps
  ticket_data: courtesyDataConstructorProps[]
}

export type courtesyDataConstructorProps = {
  title: string
  bind: string
  value?: string
}

export const payloadConstructor = (data: any): any => {
  const { event, user, pdv, ticket, quantity } = data
  return {
    quantity,
    event_id: event,
    ticket_id: ticket.ticket_id,
    ticket_lote: ticket.ticket_lote_id,
    ticket_type: ticket.ticket_type,
    user_id: user.id,
    user_name: user.nome,
    user_email: user.email,
    user_cpf: user.cpf_nao_formatado,
    pdv_serial: pdv,
  }
}

export const courtesyDataConstructor = (
  values: CourtesyRequestInitialProps,
  sectors: CourtesySectorProps[]
): courtesyDataConstructorProps[] => {
  const selected = getSelectedTickets(values, sectors)
  const data = [
    {
      title: 'Cortesia',
      bind: 'ticket_title',
      value: selected.ticket?.ticket_name,
    },
    {
      title: 'Setor',
      bind: 'ticket_gender',
      value: selected.sector?.sector_name,
    },
    {
      title: 'Sexo',
      bind: 'ticket_gender',
      value: getGenderDescription(selected.ticket?.ticket_gender as any),
    },
  ]
  return data
}

export const getSelectedTickets = (
  values: any,
  sectors: CourtesySectorProps[]
): {
  sector: CourtesySectorProps | undefined
  ticket: CourtesyTicketsProps | undefined
} => {
  const sector = sectors?.find(
    (sector: any) => sector.sector_id === values.sector_id
  )
  const ticket = sector?.tickets.find(
    (ticket: any) => ticket.ticket_id === values.ticket_id
  )
  return {
    sector,
    ticket,
  }
}

export const StepInfoData = (
  currentStep: number,
  limit: number
): {
  stepInfo: string
  subInfo: string
} => {
  if (currentStep === 1)
    return { stepInfo: 'Setores', subInfo: 'Selecione o setor.' }
  if (currentStep === 2)
    return { stepInfo: 'Ingressos', subInfo: 'Selecione o ingresso.' }
  if (currentStep === 3)
    return {
      stepInfo: 'Quantidade de Cortesias',
      subInfo: `Informe a quantidade que deseja distribuir. Quantidade máxima de ${limit} cortesias.`,
    }
  if (currentStep === 4)
    return {
      stepInfo: 'Dados do cliente',
      subInfo: 'Insira o CPF sem traços ou pontos. Ou e-mail do cliente.',
    }

  if (currentStep === 5) {
    return {
      stepInfo: 'Confirmação de dados',
      subInfo: 'Verifique os dados do envio',
    }
  } else {
    return { stepInfo: '', subInfo: '' }
  }
}
